export default function TrustFeatures({ content }) {
    const defaultFeatures = [
      {
        icon: (
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 6h11v9H3V6zm11 3h4l3 3v3h-7V9zM6.5 20a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm11 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        title: "Express Shipping",
        text: "Ships in 1-2 days after receiving your order. Orders made on Saturday or Sunday will ship the following Monday.",
      },
      {
        icon: (
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21 12c0 4.418-4.03 8-9 8-1.09 0-2.13-.174-3.09-.492L3 20l1.395-4.185C3.512 14.66 3 13.375 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        title: "24/7 Support",
        text: "Our team is here whenever you need us",
      },
      {
        icon: (
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="5" y="11" width="14" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
            <path
              d="M8 11V7a4 4 0 118 0v4"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        ),
        title: "Secured Payment",
        text: "Safe, encrypted checkout every time",
      },
    ];
    const features = content?.features?.length === 3 ? content.features.map((feature, i) => ({ ...defaultFeatures[i], ...feature })) : defaultFeatures;
  
    return (
      <section
        className="w-full bg-gray-50"
        style={{
          paddingTop: "60px",
          paddingBottom: "60px",
          paddingLeft: "clamp(24px, 5vw, 80px)",
          paddingRight: "clamp(24px, 5vw, 80px)",
        }}
      >
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center md:items-start justify-between gap-12 md:gap-6">
          {features.map((feature, i) => (
            <div key={i} className="flex flex-col items-center text-center max-w-[300px]">
              <div
                className="flex items-center justify-center rounded-full bg-gray-200 text-teal-600"
                style={{ width: "64px", height: "64px" }}
              >
                {feature.icon}
              </div>
  
              <h3
                className="text-gray-800 font-semibold"
                style={{ fontSize: "15px", marginTop: "18px" }}
              >
                {feature.title}
              </h3>
  
              <p
                className="text-gray-500"
                style={{ fontSize: "13px", marginTop: "8px", lineHeight: "1.5" }}
              >
                {feature.text}
              </p>
            </div>
          ))}
        </div>
      </section>
    );
  }